export default __webpack_public_path__ + "static/media/trippin.d4ebdb1a.png";